module.exports = __webpack_public_path__ + "img/add-filter.3cdbe612.svg";